import { useEffect } from "react";

export function usePageMeta(title, description, keywords, appendBaseTitle = true) {
  useEffect(() => {
    const baseTitle = "Vaana BuildLogic Technologies";
    document.title = title ? (appendBaseTitle ? `${title} | ${baseTitle}` : title) : `${baseTitle} | Enterprise IT, ERP, Cloud & Cybersecurity Solutions in Delhi NCR`;

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);

      let ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.setAttribute("content", description);

      let twDesc = document.querySelector('meta[name="twitter:description"]');
      if (twDesc) twDesc.setAttribute("content", description);
    }

    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) metaKeywords.setAttribute("content", keywords);
    }

    if (title) {
      const resolvedTitle = appendBaseTitle ? `${title} | ${baseTitle}` : title;
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.setAttribute("content", resolvedTitle);

      let twTitle = document.querySelector('meta[name="twitter:title"]');
      if (twTitle) twTitle.setAttribute("content", resolvedTitle);
    }
  }, [title, description, keywords, appendBaseTitle]);
}
